module.exports = __webpack_public_path__ + "static/media/risk5.9d21c6eb.jpg";